import { Link } from "react-router-dom";

const defaultLinks = [
  { to: "/totalwirelessmasteragent", label: "Total Wireless Master Agent" },
  { to: "/become-dealer", label: "Become a Dealer" },
  { to: "/locations", label: "Store Locations" },
  { to: "/careers", label: "Careers" },
  { to: "/our-process", label: "Our Process" },
  { to: "/open-a-store", label: "Open a Store" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact Us" },
];

export function InternalLinks({ exclude = "" }) {
  const links = defaultLinks.filter((l) => l.to !== exclude);
  return (
    <section className="py-12 bg-white border-t border-slate-100">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-sm text-slate-400 font-body mb-4">Explore More</p>
        <div className="flex flex-wrap justify-center gap-3">
          {links.map((link, i) => (
            <span key={link.to} className="flex items-center gap-3">
              {i > 0 && <span className="text-slate-300">·</span>}
              <Link to={link.to} className="text-sm font-body text-teal hover:underline">{link.label}</Link>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
